<section class="search-section">
<form [formGroup]="form">

  <span tabindex="0" class="focus-trap"></span>

  @if (loading) {
    <div class="loading-overlay">
      <mat-spinner />
    </div>
  }

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Condominio</mat-label>
    <input matInput formControlName="idCondominium" [matAutocomplete]="condominiumAuto" />
    <mat-autocomplete #condominiumAuto="matAutocomplete" [displayWith]="displayCondominium" (optionSelected)="onCondominiumSelected($event)">
      @for (option of filteredCondominiums(); track option.id) {
        <mat-option [value]="option.id">{{ option.name }}</mat-option>
      }
    </mat-autocomplete>
    @if (form.controls.idCondominium.hasError('required')) {
      <mat-error>El condominio es requerido</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Casa</mat-label>
    <input matInput formControlName="idHouse" [matAutocomplete]="houseAuto" />

    <mat-autocomplete #houseAuto="matAutocomplete" [displayWith]="displayHouse" (optionSelected)="onHouseSelected($event)">
      @for (option of filteredHouses(); track option.id) {
        <mat-option [value]="option.id">{{ option.street }}</mat-option>
      }
    </mat-autocomplete>
    @if (form.controls.idHouse.hasError('required')) {
      <mat-error>La casa es requerida</mat-error>
    }
  </mat-form-field>

  <button mat-raised-button type="button" (click)="search()">
    Buscar
  </button>

  <mat-divider></mat-divider>

</form>
</section>

<section class="invitation-section">
  <form [formGroup]="formInvitation">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Ingresa un código QR</mat-label>
      <input matInput formControlName="qrString" />
      @if (formInvitation.controls.qrString.hasError('required')) {
        <mat-error>El QR es requerido</mat-error>
      }
    </mat-form-field>

    <button mat-raised-button type="button" (click)="searchByQr()">
      Buscar por QR
    </button>
  </form>
</section>

<section class="qr-status-section">
  <div class="qr-status-row">
    <span class="qr-state-indicator" [class.connected]="signalrService.connectionState() === 'Connected'"></span>
    <span class="qr-state-label">{{ signalrService.connectionState() }}</span>
  </div>

  @if (lstInvitations().length > 0) {
    <div class="qr-table-container">
    <table mat-table [dataSource]="lstInvitations()" class="qr-table">

      <ng-container matColumnDef="nameCondominium">
        <th mat-header-cell *matHeaderCellDef>Condominio</th>
        <td mat-cell *matCellDef="let row">{{ row.nameCondominium }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Invitado</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <ng-container matColumnDef="nameResident">
        <th mat-header-cell *matHeaderCellDef>Residente</th>
        <td mat-cell *matCellDef="let row">{{ row.nameResident }}</td>
      </ng-container>

      <ng-container matColumnDef="house">
        <th mat-header-cell *matHeaderCellDef>Unidad</th>
        <td mat-cell *matCellDef="let row">{{ row.house }}</td>
      </ng-container>

      <ng-container matColumnDef="date1">
        <th mat-header-cell *matHeaderCellDef>Inicio</th>
        <td mat-cell *matCellDef="let row">{{ row.date1 | date:'dd/MM/yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="date2">
        <th mat-header-cell *matHeaderCellDef>Fin</th>
        <td mat-cell *matCellDef="let row">{{ row.date2 | date:'dd/MM/yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let row">{{ row.status }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Acciones</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button color="primary" (click)="goToRegister(row)" matTooltip="Registrar ingreso">
            <mat-icon>app_registration</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="qrTableColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: qrTableColumns;" [class.row-vencido]="row.status === STATUS_VENCIDO"></tr>
    </table>
    </div>
  }
</section>
